import { useState } from 'react';
import Accordion from './Accordion';

interface RaviListItem {
  hint: string;
  raviId: number;
}

interface SanadItem {
  raviList: RaviListItem[];
  type: number;
  title: string;
  order: number;
}

interface Chain {
  sanad: SanadItem[];
}

export default function ChainsSection({ chains, setNarratorInfoModalVisible, showChain, setNarratorId }: any) {
  const [chainsAccordionOpen, setChainsAccordionOpen] = useState(false);
  const parsedChains: Chain[] = (() => {
    // try parsing chains
    try {
      return JSON.parse(chains) || [];
    } catch (e) {
      return [];
    }
  })();

  console.log(parsedChains, 'PPP');

  return (
    <Accordion open={showChain}>
      <div className="overflow-none divide-y border-t-2 m-4">
        <div className="mt-4">
          {parsedChains?.map((c, i) => chainComponent(c, setNarratorInfoModalVisible, setNarratorId, i))}
        </div>
      </div>
    </Accordion>
  );
}

function chainComponent(chain: Chain, setNarratorInfoModalVisible: any, setNarratorId: any, key: number) {
  //TODO: better break line solution
  return (
    <p key={key} dir="rtl">
      {chain.sanad.map((s, i) => sanadComponent(s, setNarratorInfoModalVisible, setNarratorId, i))}
      <br></br>
      <br></br>
    </p>
  );
}

function sanadComponent(sanad: SanadItem, setNarratorInfoModalVisible: any, setNarratorId: any, key: number) {
  if (sanad?.raviList != null)
    return (
      <a
        key={key}
        style={{ color: '#0072f5' }}
        title={sanad?.raviList[0].hint}
        onClick={() => {
          setNarratorId(sanad?.raviList[0].raviId);
          setNarratorInfoModalVisible(true);
        }}
      >
        {sanad?.title}{' '}
      </a>
    );
  else return <span key={key}>{sanad?.title + ' '}</span>;
}
